<template>
  <div class="media-library">
    <h1>Mediathek</h1>
    <fin-data-loader :resolver="loadEntries">
      <template #content>
        <fin-academy-grid :posts="academyEntries" class="video-grid"/>
        <div v-intersect="onIntersect"/>
      </template>
    </fin-data-loader>

  </div>
</template>


<script>
import FinAcademyGrid from "@/components/pages/finAcademy/grid/AcademyGrid"
import FinDataLoader from "@/components/common/DataLoader"
import {mapGetters} from "vuex"

export default {
  name: "FinAcademyMediaLibrary",
  components: {
    FinDataLoader,
    FinAcademyGrid
  },
  data() {
    return {
      academyEntries: [],
      nbOfEntriesToLoad: 12,
      initialNbOfEntriesToLoad: 12
    }
  },
  computed: {
    ...mapGetters('auth', ['userId', 'groupPriceModel']),
  },
  methods: {
    // videos, texts, podcasts
    async loadEntries(afterEntryId = undefined, pageSize = this.initialNbOfEntriesToLoad) {
      const docTypePredicates = this.$prismic.Predicates.at('document.type', 'academy_entry')
      //const aboPredicates = this.$prismic.Predicates.at('my.academy_entry.' + this.groupPriceModel.id.toLowerCase(), true)
      const query = [docTypePredicates /*, aboPredicates*/]
      const queryResults = await this.$prismic.client.query(query, {
        orderings: '[my.academy_entry.date desc, document.first_publication_date]',
        after: afterEntryId,
        // TODO accessToken
        pageSize: pageSize
      })

      // TODO two ways: videos prismic and videos youtube
      const entries = queryResults.results.map((entry, index) => ({
        ...entry.data,
        _meta: {
          uid: entry.uid,
          tags: entry.tags,
        },
        date: entry.data.date !== 0 ? entry.data.date : entry.first_publication_date,
        url: '/academy-entry/' + entry.uid,
        id: entry.id,
        origEntry: entry
      }))
      console.log("entries", entries)
      this.academyEntries = this.academyEntries.concat(entries)
    },
    onIntersect(entries, observer) {
      if (entries[0].intersectionRatio >= 0.5) {
        this.loadEntries(this.academyEntries[this.academyEntries.length - 1].id, this.nbOfEntriesToLoad)
      }
    }
  }
}
</script>

<style lang="scss" scoped>
::v-deep .video-grid {
  display: flex;

  .card-link {
    text-decoration: none;

    .v-card {
      background-color: transparent;
      border: 0
    }
  }
}
</style>
